import i18n from '@maia/i18n';

export type Variant =
  | 'default'
  | 'success'
  | 'error'
  | 'warning'
  | 'info'
  | 'inactive';

export type CreateLookupTable = Record<string, Variant>;

export function createLookupTable(
  table: CreateLookupTable,
  resource:
    | 'claim'
    | 'insurance'
    | 'quotation'
    | 'taskStatus'
    | 'taskPriority'
    | 'customer'
    | 'payment',
): Record<string, [Variant, string]> {
  return Object.fromEntries(
    Object.entries(table).map(([key, value]) => [
      key,
      [value, i18n.t(`tags.${resource}.${key}`, { ns: 'system' })],
    ]),
  );
}
